
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $24e106461d3ed622$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"IOlTS\",\"SpaceSettingsNavigationPortal.5f596396.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.f7a3f316.js\",\"eMbU0\",\"SpaceSelector.0f327f45.js\",\"3wN5D\",\"ExternalSpaceLozenge.11ec98f6.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"etEYy\",\"manual-triggers-modal.06c1c832.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.dc2e262e.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.f3198cb5.js\",\"7EorR\",\"vendors~editor_atlaskit_md.c42d53e3.js\",\"gfd9j\",\"simpleHasher.7dd977bc.js\",\"76Ngy\",\"simpleHasher.runtime.983da2c7.js\",\"31vk5\",\"main.ef834ad2.js\",\"7cABH\",\"emoji.4fc2f880.js\",\"2vAWg\",\"emoji.runtime.43c82fbe.js\",\"hogcU\",\"component-lazy.c401bc70.js\",\"lBssV\",\"FullPageEditorComponent.1d80dcdd.js\",\"fiBiE\",\"FullPageEditorComponent.runtime.85711374.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"ffEVr\",\"vendors~editor_icon.d6c392c9.js\",\"9GDly\",\"SpaceSelector.28943286.js\",\"lJJQ8\",\"ViewChangesDialog.4b1c81e6.js\",\"8OiWl\",\"ChangesDiff.266f7784.js\",\"dtpmo\",\"SpaceSelector.5345b636.js\",\"6wr18\",\"vendors~editor_icon.181a3fa4.js\",\"fiBiE\",\"FullPageEditorComponent.runtime.85711374.js\",\"2vAWg\",\"emoji.runtime.43c82fbe.js\",\"76Ngy\",\"simpleHasher.runtime.983da2c7.js\",\"4yUSc\",\"PremiumLozenge.3c02361d.js\",\"ePA5l\",\"Lozenge.0b4adf81.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"1yVM6\",\"UpgradeEditionButton.9e676a8d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.c2f41061.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"6XCf4\",\"LearnMoreButton.74b58cfa.js\",\"cEqm7\",\"ShareButton.0b6a7f9e.js\",\"hOaAV\",\"ExtensionConfigUpsell.91a5174d.js\",\"7JvFY\",\"CopySpacePermissionsForLegacyNewSpace.69f9b57d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.c2f41061.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("DNq0w")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.532ff289.js.map
